<template lang="pug">
v-container.align-self-start.justify-center.invoice-page-container(:no-gutters="!$vuetify.breakpoint.mobile")
    v-card.fill-height(flat v-if="!fetchInProgress")
        v-card-title {{ $t('navigationItem.billingPageLabel') }}
        v-list.ma-0(three-line :dense="$vuetify.breakpoint.xs")
            v-list-item(v-for="invoice in invoices" :key="invoice.id" three-line v-ripple @click="onInvoiceItemClick(invoice)")
                v-list-item-content(v-if="invoice === currentInvoiceToDownload")
                    v-progress-circular(indeterminate :color="invoice.paymentStatusColor")
                template(v-else)
                    v-list-item-action.mr-4(:class="statusIconBoxClass")
                        v-icon.status-icon(:color="invoice.paymentStatusColor" :x-large="$vuetify.breakpoint.mdAndUp") {{ invoice.paymentStatusIcon }}

                    v-list-item-content.flex-grow-1.flex-shrink-1
                        v-list-item-title
                            strong {{ getInvoiceName(invoice) }}

                        v-list-item-content.pa-0(v-if="$vuetify.breakpoint.xs")
                            v-row.ma-0.pa-0
                                v-col.pa-0(cols="7")
                                    v-list-item-subtitle {{ invoice.formattedPeriodRange }}
                                    v-list-item-subtitle {{ invoice.paymentStatusLabel }}
                                v-col.pt-0.font-weight-bold.text-end.pr-0.text-no-wrap(cols="5") {{ invoice.formattedPriceItemSum }} &euro;

                        v-list-item-content.pa-0(v-if="$vuetify.breakpoint.smAndUp")
                            v-list-item-subtitle
                                div {{ invoice.formattedPeriodRange }}
                            v-list-item-subtitle {{ invoice.paymentStatusLabel }}

                    v-list-item-content.text-end(v-if="$vuetify.breakpoint.smAndUp" :class="$vuetify.breakpoint.smAndDown && 'align-start'")
                        span.font-weight-bold.text-h5 {{ invoice.formattedPriceItemSum }} &euro;

                    v-list-item-action(v-if="$vuetify.breakpoint.smAndUp")
                        v-icon.pl-4(color="primary" :x-large="$vuetify.breakpoint.mdAndUp") fas fa-download

    v-skeleton-loader(v-else type="paragraph@7 " width="100%")
</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {DOWNLOAD_INVOICE, FETCH_INVOICES,} from '@/store/action-types'
import {Invoice} from '@/model/Invoice'

@Component({
  components: {}
})
export default class BillingPage extends Vue {
  @Action(FETCH_INVOICES) fetchInvoices!: ({ (): Promise<Invoice[]> })
  @Action(DOWNLOAD_INVOICE) downloadInvoice!: ({ (invoice: Invoice): Promise<void> })

  private fetchInProgress: boolean = false
  private currentInvoiceToDownload: Invoice|null = null
  private invoices: Invoice[] = []

  get statusIconBoxClass(): string {
    return this.$vuetify.breakpoint.mdAndUp ? 'icon-box-lg' : 'icon-box-sm'
  }

  getInvoiceName(invoice: Invoice): string {
    let name = invoice.name

    // specificka logika pre mesacne vyuctovania,
    // skracuje sa nazov
    if (invoice.name.includes(',')) {
      name = invoice.name.substr(invoice.name.lastIndexOf(',') + 1).trim()
    }

    return name
  }

  async onInvoiceItemClick(invoice: Invoice): Promise<void> {
    if (!this.currentInvoiceToDownload) {
      try {
        this.currentInvoiceToDownload = invoice
        await this.downloadInvoice(invoice)
      } catch (e) {
        // TODO
      } finally {
        this.currentInvoiceToDownload = null
      }
    }
  }

  async fetchData(): Promise<void> {
    try {
      this.fetchInProgress = true
      this.invoices = await this.fetchInvoices()
    } catch (e) {
      // TODO
    } finally {
      this.fetchInProgress = false
    }
  }

  mounted(): void {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>

.invoice-page-container
  max-width 700px

.icon-box-lg
  width 45px

.icon-box-sm
  width 27px

</style>
